var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 3.69193V1.39441C8.50042 1.14199 8.72434 0.93742 9.00051 0.9375C9.14213 0.937527 9.27708 0.992478 9.37189 1.08864L13.872 5.65901C14.0366 5.82654 14.0432 6.07864 13.8875 6.25316L9.38736 11.2805C9.21251 11.4759 8.89749 11.5047 8.68374 11.3449C8.56795 11.2583 8.50065 11.1289 8.50033 10.9922V8.71476C4.55018 8.83221 2.0851 10.3756 0.974039 13.4222C0.905892 13.6086 0.715016 13.7343 0.500028 13.7344C0.473074 13.7345 0.446119 13.7324 0.419517 13.7284C0.177632 13.6924 0 13.5014 0 13.2773C2.95639e-05 7.89528 3.54464 3.94146 8.50033 3.69193Z",
    fill: "#EAEAF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrow);
export default __webpack_public_path__ + "static/media/arrrow.2029c026f96c0364e3026f570a5fd8a8.svg";
export { ForwardRef as ReactComponent };